module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAIdJREFUOE9jZKAAMFKgl2EQaX7Eqbn/PzNTtvyXq9dgXnrIo63F+PffVLnv1x2RvYnh7Edc2qb/Gf7PZ2BiDAMZANLI8O//Khgfr2aQJFwDA2MlA8P/dmwaQepwBthDLm1fBob/qxkYGEPlv13djC1WsGom22Z0P5LkZ4pCm5QUN4hSGCnOBgApcEwQWW3M8AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no.png
// module id = nP1P
// module chunks = 5